import React, { useEffect, useRef, useState } from 'react'
import moment from "moment"
import classNames from 'classnames';
import { ReactComponent as BackArrow } from "./../../back-arrow.svg"
import { ReactComponent as MoreElipsis } from "./../../more-elipsis.svg"
import { ReactComponent as CopyIcon } from "./../../copy-link-icon.svg"
import { ReactComponent as DeleteIcon } from "./../../delete-icon.svg"
import { ReactComponent as ListIcon } from "../../../../../assets/svg/static-assets/grid.svg"
import { ReactComponent as GridIcon } from "../../../../../assets/svg/static-assets/list.svg"
import { useHistory, useParams } from 'react-router-dom';
import { Popover } from '@headlessui/react'
import { FiLink2, FiTrash2 } from "react-icons/fi";

import "./style.scss";
import { useToast } from '../../../../../helpers/commonFunction';
import { Http } from '../../../../../helpers/axois';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, RootState } from '../../../../../stateManager/store';
import { createNewImageAsset, fetchAllStaticAssetsByFiletype, deleteImageAssetById } from '../../../../../stateManager/store/static-assets/action';
import { Table } from 'antd';
import SearchBar, { highlightMatch } from '../../../../../helpers/SearchBar';

const ADD_NEW_BTN = "+ New";
const COPY_URL_BTN = "Copy Url";
const PAGE_TITLE = "Images"
const PAGE_SUBTITLE = "View, upload or remove images from assets"

interface Window {
  Image: {
    prototype: HTMLImageElement;
    new(): HTMLImageElement;
  };
}

export const ImagesFolder = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { SuccessToast, ErrorToast } = useToast();
  const params: { appId: string } = useParams();
  const imageFiles = useSelector((state: RootState) => state.staticAssets.images)
  const orgId = useSelector((state: AppState) => state.org.selectedOrg.id);
  const [selectedImageId, setSelectedImageId] = useState("")
  const [isGridLayout, setGridLayout] = useState(true)
  const [filteredData, setFilterData] = useState<any[]>([])
  const searchRef = useRef<{ clearSearch: () => void }>(null);
  const [searchValue, setSearchValue] = useState<string>("")
  const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
  const orgPermissions: any = useSelector((state: AppState) => {
    return state.org.orgPermissions
}, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const handleBackArrowClick = () => {
    history.goBack();
  }
  const prevImageFilesRef = useRef<typeof imageFiles | null>(null);
  const columns = [
    {
      title: "Name",
      dataIndex: "filename",
      key: "filename",
      width: "50%",
      render: (value: string)=>{
        const formattedValue = highlightMatch(value, searchValue)
        return formattedValue
      }
    },
    {
      title: "File Size",
      dataIndex: "size",
      key: "size",
      width: "20%",
      render: (value: string)=>{
        const formattedValue = highlightMatch(value, searchValue)
        return formattedValue
      }
    },
    {
      title: "Last Modified Date",
      dataIndex: "updated_at",
      key: "updated_at",
      width: "20%",
      render: (value: string)=>{
        const formattedValue = highlightMatch(value, searchValue)
        return formattedValue
      }
    },
    {
      title: "Actions",
      key: "actions",
      render: (text: any, record: any) => (
        <div className="action">
          <span
            data-test-id="action_policy"
            className="action-icon edit-icon"
            title='Copy Image Link'
            onClick={e => {
              e.stopPropagation();
              handleImageFileUrlCopy(record.id)
            }}
          >
            <FiLink2 style={{ transform: "rotate(135deg)" }} />
          </span>
          <span
            data-test-id="action_edit"
            title='Delete'
            className="action-icon delete-icon"
            onClick={e => {
              e.stopPropagation();
              handleImageFileDelete(record.filename, record.id)
            }}
          >
            <FiTrash2 data-test-id="table" height='15px' width='15px' />
          </span>
        </div>
      )
    }
  ];

  const listView = Object.values(imageFiles).map((item: any) => {
    return {
      key: item.id,
      id: item.id,
      filename: item.filename,
      size: item.size,
      url: item.url,
      updated_at: item?.updated_at ? moment(item.updated_at).local().format("DD-MM-YYYY hh:mm a") : "-" 
    }
  })

  const fetchImageFiles = () => {
    const payload = {
      "appId": params.appId,
      "filetype": "image",
      orgId
    }
    dispatch(fetchAllStaticAssetsByFiletype(payload))
  }

  const checkIfImageExists = async (url: string): Promise<boolean> => {
    return new Promise(resolve => {
      var img = new window.Image();
      img.onload = function () {
        resolve(true)
      }
      img.onerror = function () {
        resolve(false)
      }
      img.src = url;
    })
  }

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if((!orgPermissions?.includes("staticAsset.Create") || !orgPermissions?.includes("staticAsset.View") || !orgPermissions.includes('app.View')) && loggedInUserId!=selectedOrg?.owner ){
        ErrorToast("Not Authorized: Please request owner of this organization to provide access")
       return
      }
      if (e.target.files?.length) {
        const file: File = e.target.files[0];
        const { type, name, size } = file;
        // todo: Check for upload size restriction
        if (type.includes("image")) {
          const fileUrl = URL.createObjectURL(file)
          const isValidImage = await checkIfImageExists(fileUrl)
          if (isValidImage) {
            const [fileName, ext] = name.split(".")
            const updated_filename = `${fileName.replaceAll(" ", "").replaceAll("(", "").replaceAll(")", "")}_${Date.now()}.${ext}`
            // todo: request for presigned url
            const payload = {
              filetype: type,
              filename: updated_filename,
              orgId,
              appId: params.appId
            }
            const resp: any = await Http.post("/static-asset/get-upload-url", payload, {
              headers: {
                "Content-Type": "application/json"
              }
            }).toPromise()
            if (resp.ok) {
              // upload to presigned url
              await Http.put(resp.url, file, {
                headers: {
                  "Content-Type": type
                }
              }).toPromise();
              // update data with asset
              try {
              const data: any = await Http.post("/static-asset/create", {
                appId: params.appId,
                filename: updated_filename,
                filetype: "image",
                url: resp.filePath,
                size,
                orgId
              }).toPromise()
              searchRef.current?.clearSearch()
              dispatch(createNewImageAsset(data))
              SuccessToast("Image uploaded successfully")
              } catch (e) {
                if (e === "Forbidden") {
                  ErrorToast("Not Authorized: Please request owner of this organization to provide access")
                }
              }
            }
            // todo: update redux
          } else {
            ErrorToast("Invalid Image")
          }
        }
      }
    } catch (error) {
      console.error(error)
      ErrorToast("Invalid image")
    }
  }

  const handleImageFileUrlCopy = (id: string) => {
    const url = imageFiles[id].url
    navigator.clipboard.writeText(url);
    SuccessToast("URL copied to clipboard")
  }

  const handleImageFileDelete = async (filename: string, id: string) => {
    const endpoint = `/static-asset`;
    try {
      const payload: any = {
        appId: params.appId,
        orgId,
        id: id,
        filename,
      };
      const data: any = await Http.put(endpoint, payload).toPromise();
      if (data.ok) {
        dispatch(deleteImageAssetById({ id }))
        searchRef.current?.clearSearch()
        SuccessToast('Successfully deleted file');
      } else {
        throw new Error("Failed to delete the file")
      }
    } catch (err) {
      if (err instanceof Error) {
        const msg = err.message || 'Failed to delete file';
        ErrorToast(msg);
      } else {
        ErrorToast("Failed to delete file");
      }
    }
  }

  const handleLayoutSwitch = (e: any) => {
    e.stopPropagation();

    setGridLayout(prev => !prev)
  }

  useEffect(() => {
    searchRef.current?.clearSearch()
    fetchImageFiles();
    setFilterData(listView)
  }, [])
  
  useEffect(() => {
    if (!prevImageFilesRef?.current || JSON.stringify(prevImageFilesRef?.current) !== JSON.stringify(imageFiles)) {
      prevImageFilesRef.current = imageFiles;    
      setFilterData(listView)
    }
  }, [imageFiles]);

  return (
    <div className="images-wrapper">
      <div className="images-header__container">
        <div className="images-header__content-wrapper">
          <div className="header">
            <BackArrow className='backarrow' onClick={handleBackArrowClick} />
            <div className="header-content">
              <div className="header-content--title">{PAGE_TITLE}</div>
              <div className="header-content--subtitle">{PAGE_SUBTITLE}</div>
            </div>
          </div>
          <div className="submit-wrapper items-center">
            <SearchBar
              ref={searchRef}
              data={listView}
              columns={columns}
              onFilter={(filteredData ) => {
                  setFilterData(filteredData)
              }}
              onSearchTermChange={ (searchValue: string)=>{ setSearchValue(searchValue) } }
            />
            <div className='layout-icon'>
              {isGridLayout ? <GridIcon title='Grid view' onClick={handleLayoutSwitch} /> : <ListIcon title='List view' onClick={handleLayoutSwitch} />}
            </div>
            <div className="file-input-wrapper">
              <input id="imageInput" type="file" accept="image/*" hidden onChange={handleImageUpload} />
              <label htmlFor="imageInput" className="add-new-btn">{ADD_NEW_BTN}</label>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="images-body__container">
        {isGridLayout ? <div className="body__wrapper--grid">
          {filteredData.map((item: any) =>
            <Image
              id={item.id}
              selectedImageId={selectedImageId}
              setSelectedImageId={setSelectedImageId}
              key={item.id}
              url={item.url}
              name={item.filename}
              searchValue={searchValue}
              handleImageFileUrlCopy={handleImageFileUrlCopy}
              handleImageFileDelete={handleImageFileDelete}
            />)}
        </div> :
          <div className="body__wrapper--list">
            <Table
              pagination={false}
              scroll={{ y: 'calc(100vh - 200px)'}}
              columns={columns}
              onRow={(record: any, rowIndex: any) => {
                return {
                  'data-test-id': 'app_table_row_' + record.key,
                  onClick: (event: any) => {
                    let target: any = event.target;

                  }
                };
              }}
              className='override-table-container-app'
              dataSource={filteredData}
            />
          </div>
        }

      </div>
    </div>
  )
}


const Image = ({ id, url, name, setSelectedImageId, selectedImageId, handleImageFileUrlCopy, handleImageFileDelete, searchValue }: { id: string, url: string, name: string, setSelectedImageId: (arg: string) => void, selectedImageId?: string, handleImageFileUrlCopy: (id: string) => void, handleImageFileDelete: (filename: string, id: string) => void , searchValue: string}) => {

  const [popOverState, setPopOverState] = useState(false);
  const popoverRef = useRef<HTMLDivElement | null>(null);
  const MARGIN_RIGHT = 8;
  const MARGIN_LEFT = 16; 
  
  const handlePopoverPosition = () => {
    const popover = popoverRef.current;
    if (popover) {
      const popoverRect = popover.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      if (popover) {
        popover.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }
      // Check if the popover is too far right
      if (popoverRect.right > windowWidth) {
        popover.style.right = `${MARGIN_RIGHT}px`;
        popover.style.left = "auto";
      } else if (popoverRect.left < MARGIN_LEFT) {
        popover.style.left = `${MARGIN_LEFT}px`;
        popover.style.right = "auto";
      }
    }
  };

  useEffect(() => {
    if (popOverState) {
      handlePopoverPosition();
    }
    return () => {
      setPopOverState(false);
    };
  }, [popOverState]);

  return (
    <div className={classNames("item", { selected: selectedImageId === id })} onClick={() => setSelectedImageId(id)}>
      <div className="img-wrapper" style={{ backgroundImage: `url(${url})` }}></div>
      <div className="details-wrapper">
        <div title={name} className="filename">{highlightMatch(name.substring(0, 15), searchValue)}{name.length > 18 ? "..." : ""}</div>
        <div className="more-icon-wrapper">
          <Popover className="relative image-context-popover" >
            <Popover.Button className="more-icon-button" onClick={() => setPopOverState(true)}>
              <MoreElipsis />
            </Popover.Button>

           <Popover.Panel  ref={popoverRef} className="image-context-menu absolute z-10">
              {({ close }) => (
                <ul className='more-icon-list'>
                  <li>
                    <button onClick={() => { handleImageFileUrlCopy(id); close(); }}>
                      <CopyIcon /> Copy Link
                    </button>
                  </li>
                  <li>
                    <button onClick={() => { handleImageFileDelete(name, id); close(); }}>
                      <DeleteIcon /> Remove
                    </button>
                  </li>
                </ul>
              )}
            </Popover.Panel>
          </Popover>
        </div>
      </div>
    </div>
  )
}